/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Box, IconButton, Stack } from "@mui/material";

import MaterialSymbol from "../../../../../components/MaterialSymbol";
import TextField from "../../../../../components/TextField";

import CategoriesDropDown from "./CategoriesDropDown";

export interface FilterState {
  searchText: string | undefined;
  sortBy: string;
  currentPage: number;
  category: string | undefined;
}

interface ProductListFilterProps {
  filter: FilterState;
  setFilter: React.Dispatch<Partial<FilterState>>;
}

export function filterReducer(prev: FilterState, next: Partial<FilterState>) {
  return { ...prev, ...next };
}

const ProductListFilter: React.FC<ProductListFilterProps> = ({ filter, setFilter }) => {
  const hasTextSearch = filter.searchText?.length ? filter.searchText?.length > 0 : false;
  return (
    <Stack direction="column">
      <Stack direction={{ xs: "column", md: "row" }} alignItems="center" gap={2} overflow="hidden">
        <Box flex={{ xs: 1, md: 5 }} width="100%">
          <TextField
            variant="outlined"
            placeholder="Search products"
            value={filter.searchText}
            onChange={(event) => setFilter({ searchText: event.target.value })}
            InputProps={{
              endAdornment: (
                <Stack direction="row" gap={1}>
                  {hasTextSearch ? (
                    <IconButton
                      color="default"
                      title="Clear"
                      style={{ padding: 0, width: "24px", height: "24px" }}
                      onClick={() => setFilter({ searchText: "" })}
                    >
                      <MaterialSymbol sx={{ fontSize: "20px" }}>close</MaterialSymbol>
                    </IconButton>
                  ) : null}
                  <IconButton color="primary" title="Search" style={{ padding: 0 }}>
                    <MaterialSymbol>search</MaterialSymbol>
                  </IconButton>
                </Stack>
              ),
            }}
          />
        </Box>
        <Box flex={{ xs: 1, md: 6 }}>
          <CategoriesDropDown
            value={filter.category}
            onCategoryChange={(value) => setFilter({ category: value })}
          />
        </Box>
      </Stack>
    </Stack>
  );
};

export default ProductListFilter;
